import { programFromBE } from '@common/api/programs';
import backend from '@common/backend';

const BASE = '/lessons';

export type GetLessonsQuery = {
	program_id: number;
	module_id: number;
	search?: string;
	page?: number;
	limit?: number;
};

export type GetLessonsBooksQuery = {
	search?: string;
	page?: number;
	limit?: number;
};

export type CreateLessonData = {
	program_id: number;
	module_id?: number;
	lesson_type_id: number;
	name: string;
	weight?: number;
	is_published?: number;
	cover_url?: string;
};

const lessonToBE = ({ lessonType, ...lesson }: any) => ({
	...lesson,
	lesson_type_id: lessonType.id,
});

export const lessonFromBE = ({ program, weight, ...lesson }: any) => ({
	// @TODO: Remove when BE will be fixed
	...lesson,
	weight: weight ? `${weight}` : weight,
	program: programFromBE(program),
});

export const getLessons = (query: GetLessonsQuery) =>
	backend
		.get(BASE, {
			params: { ...query },
		})
		.then((lessons: any) =>
			lessons.map((lesson: any) => lessonFromBE(lesson)),
		);

export const getLesson = async (id: number) => backend.get(`${BASE}/${id}`).then(lessonFromBE);

export const postLesson = (data: CreateLessonData) => backend.post(BASE, data);

export const updateLesson = async (id: number, data: any) =>
	backend.post(`${BASE}/${id}`, lessonToBE(data)).then(lessonFromBE);

export const deleteLesson = async (id: number) => backend.delete(`${BASE}/${id}`);

export const invertPublished = async (id: number, data?: any) =>
	backend.put(`${BASE}/invertPublished/${id}`, data);

export const getLessonsBooks = (lesson_id: number, query?: GetLessonsBooksQuery) =>
	backend.get(`${BASE}/${lesson_id}/books`, { params: query });

export const attachLessonsBooks = async (lesson_id: number, data?: any) =>
	backend.patch(`${BASE}/${lesson_id}/books`, data);
